export default "__VITE_ASSET__DyYPnHtO__"